/*
 * Copyright © 2020-2023 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yongqiang
 * @LastEditTime: 2023-12-28 16:46:42
 */
import { useEffect, useState } from 'react'
import { formatStorageSize } from '../../../utils/utils'

export const useFileNums = (fileList: File[]) => {
  const [photosNum, setPhotosNum] = useState(0)
  const [videosNum, setVideosNum] = useState(0)
  const [totalSize, setTotalSize] = useState('')
  useEffect(() => {
    let photos = 0
    let videos = 0
    let total = 0
    fileList.forEach((file) => {
      if (file.type.indexOf('image') > -1) {
        photos += 1
      } else {
        videos += 1
      }
      total += file.size
    })
    const formattedSize = formatStorageSize(total, 0)
    setPhotosNum(photos)
    setVideosNum(videos)
    setTotalSize(formattedSize.size + formattedSize.unit)
  }, [fileList])
  return {
    photosNum,
    videosNum,
    totalSize
  }
}
